var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 67,
    viewBox: "0 0 66 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1884_944)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 12.9083,
    width: 34,
    height: 34,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.372 32.3717H35.6217L35.3558 32.1027C35.9493 31.3791 36.3831 30.5269 36.626 29.6069C36.869 28.687 36.9152 27.722 36.7613 26.7811C36.315 24.0107 34.1118 21.7984 31.4528 21.4596C30.518 21.3355 29.5685 21.4374 28.677 21.7576C27.7855 22.0778 26.9756 22.6078 26.3093 23.307C25.6431 24.0062 25.138 24.856 24.8329 25.7916C24.5277 26.7271 24.4306 27.7235 24.5488 28.7044C24.8717 31.4948 26.9799 33.8067 29.62 34.2751C30.5166 34.4366 31.4361 34.3881 32.3128 34.1332C33.1895 33.8782 34.0016 33.423 34.6911 32.8002L34.9475 33.0793V33.8665L38.9835 38.1019C39.3728 38.5104 40.0091 38.5104 40.3985 38.1019C40.7878 37.6933 40.7878 37.0256 40.3985 36.617L36.372 32.3717ZM30.6741 32.3717C28.3095 32.3717 26.4007 30.3687 26.4007 27.8873C26.4007 25.4059 28.3095 23.4028 30.6741 23.4028C33.0387 23.4028 34.9475 25.4059 34.9475 27.8873C34.9475 30.3687 33.0387 32.3717 30.6741 32.3717Z",
    fill: "#1A1A1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1884_944",
    x: 0,
    y: 0.908295,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.85098 0 0 0 0 0.85098 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1884_944"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1884_944",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.96eb67eed454551701f0e190d3390081.svg";
export { ForwardRef as ReactComponent };